import {
  PLANS_DOMAIN,
  PLANS_KEY,
  PLANS_PATH
} from 'modules/plan/redux/constants'
import getByIdReduxSelector from 'modules/redux/selectors/get-by-id'
import isLoadingReduxUtil from 'modules/redux/utils/is-loading'
import isLoaded from 'modules/redux/utils/is-loaded'
import getCurrentReduxSelector from 'modules/redux/selectors/get-current'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { PLAN_KEY } from '@gymaholic/packages'
import { getObjectUtil } from 'packages/src'

export function isTrainingPlansLoadingSelector () {
  return (state) => {
    return isLoadingReduxUtil(state[PLANS_DOMAIN].all)
  }
}

export function isStartedPlansLoadingSelector () {
  return (state) => {
    return isLoadingReduxUtil(state[PLANS_DOMAIN][PLANS_KEY.STARTED_PLANS])
  }
}

export function isStartedPlansLoadedSelector () {
  return (state) => {
    return isLoaded(state[PLANS_DOMAIN][PLANS_KEY.STARTED_PLANS])
  }
}

export function isTrainingPlansLoadedSelector () {
  return (state) => {
    return isLoaded(state[PLANS_DOMAIN].all)
  }
}

export function getByIdTrainingPlanSelector (id) {
  return (state) => {
    return getByIdReduxSelector(PLANS_PATH.DATA, id)(state)
  }
}

export function getByIdParamTrainingPlanSelector () {
  return (state, props) => {
    const id = getObjectUtil(props, 'match.params.id')
    return getByIdReduxSelector(PLANS_PATH.DATA, id)(state)
  }
}

export function getByIdPropTrainingPlanSelector () {
  return (state, props) => {
    return (
      getByIdReduxSelector(
        PLANS_PATH.DATA,
        props.id
      )(state)
    )
  }
}

export const getCurrentPlanSelect = getCurrentReduxSelector(
  PLANS_PATH.DATA,
  PLANS_PATH.CURRENT
)

export function getStartedPlansSelector () {
  return (state) => {
    const trainingPlans = state[PLANS_DOMAIN]
    const startedPlans = trainingPlans.startedPlans
    const plans = []
    if (startedPlans && startedPlans.data) {
      startedPlans.data.map((planId) => {
        return plans.push(trainingPlans.data[planId])
      })
      return plans
    }
  }
}

export function getAllPlansByCreatorIdSelector (creatorId) {
  return (state) => {
    const trainingPlans = state[PLANS_DOMAIN]

    const plans = []

    if (trainingPlans.data !== undefined || trainingPlans.data !== null) {
      Object.values(trainingPlans.data).forEach((trainingPlan) => {
        const profileId = getValueReduxUtil(trainingPlan, PLAN_KEY.PROFILE_ID)

        if (profileId === creatorId) {
          plans.push(trainingPlan)
        }
      })
    }

    return plans
  }
}
